module.exports = __webpack_public_path__ + "img/user.d71bad44.svg";